export const normalizeNullableDate = (
  date: Date | string | null | undefined,
): Date | null => {
  if (!date) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return new Date(date);
};
